module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pdf-forms/auctionintimation/auctionintimation.component.css
// module id = ./src/app/pdf-forms/auctionintimation/auctionintimation.component.css
// module chunks = main